module.exports = __webpack_public_path__ + "img/pt-12.60dba54a.jpg";